import React, { useState, useEffect } from "react";
import { config } from "../../config/config";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const ProjectFilter = (props) => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");

  const handleFilterChange = (e) => {
    console.log(e);
    setSelectedProject(e.target.value);
    props.onChange(e);
  };
  useEffect(() => {
    fetch(config.API_URL + `/Project`)
      .then((res) => res.json())
      .then((data) => {
        setProjects(
          data
            .map((item) => item.name)
            .filter((value, index, self) => self.indexOf(value) === index)
        );
      });
  }, []);
  return (
    <FormControl size="medium" sx={{ margin: 1.3 }}>
      <InputLabel id={`projects-select-label`}>Projects</InputLabel>
      <Select
        sx={{ minWidth: 200 }}
        labelId={`projects-select-label`}
        name="project"
        id={`projects-select`}
        value={selectedProject}
        label="Projects"
        onChange={(e) => handleFilterChange(e)}
      >
        {projects.length > 0 &&
          projects.map((s, i) => (
            <MenuItem value={s} key={i}>
              {s}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
export default ProjectFilter;
